module.exports = __webpack_public_path__ + "img/SuperGoatLifeDestruction.61cf7659.png";